const getNavigatorLanguage = () => {
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0];
  } else {
    return (
      navigator.language ||
      'en'
    );
  }
};
export default getNavigatorLanguage;
